// 可視化（コロプレス）スキル。
//
// 役割: 属性値による塗り分け（set_layer_style）の使い方をエージェントに与える。
// 関係: system-prompt.js が連結。実体は tools/register-tools の set_layer_style と
//       data/layer-service.computeChoroplethStyle。
export const VIZ_SKILL = `## スキル: コロプレス（属性値で塗り分け）

レイヤーを属性値で塗り分けるには **set_layer_style** に layer_id と fill_column を渡すだけでよい。
クラス分け・配色・凡例は自動で決まり、凡例はレイヤーパネルのレイヤー名の下に表示される。

### 手順
1. 対象レイヤーに塗り分けたい列があるか describe_layer で確認する（実在する列名を使う）。
2. set_layer_style(layer_id, fill_column) を呼ぶ。数値列は段彩（既定 quantile 5 分割）、
   文字列列はカテゴリ配色に自動判定される。
3. 調整したいときだけ任意引数を渡す:
   - method: quantile（等量・既定）/ equal_interval（等間隔）/ categorical（名義）。
   - classes: 数値段彩のクラス数（2〜9、既定 5）。
   - scheme: 連続 YlOrRd/Blues/Greens/Viridis、発散 RdBu/RdYlGn、カテゴリ Set2/Tableau10。
   - opacity: 0〜255（既定 180）。
4. 塗り分けを解除して単色に戻すには clear=true。

### 注意
- 塗り分けは地図に描画済みのレイヤーに対して行う。地物数が多すぎて未描画のレイヤーは、
  先に絞り込み/簡略化で描画してから塗る。
- 人口密度のような比率で塗りたいときは、先に run_spatial_sql で比率列を作ってから fill_column に指定する。
- 数値の大小を示すなら連続/発散、種別を示すならカテゴリの scheme を選ぶ。`
